<template>
    <div>
        <v-dialog v-model="isActive" :fullscreen="$vuetify.breakpoint.mobile" transition="dialog-bottom-transition"
            scrollable width="975" persistent>
            <v-card :flat="!$vuetify.breakpoint.mdAndDown" class="rounded-0">
                <v-card class="rounded-0 elevation-0">
                    <v-app-bar color="white" elevation="0">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" icon @click="confirmAndClose(false)"
                                    @keydown.esc="confirmAndClose(false)">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </template>
                            <span>Cerrar</span>
                        </v-tooltip>
                        <v-toolbar-title>
                            <div class="text-h6 font-weight-bold primary--text">
                                {{ titulo }}
                            </div>
                        </v-toolbar-title>
                    </v-app-bar>
                </v-card>
                <v-card-text class="pt-2">
                    <v-row class="pt-5">
                        <v-col cols="12" md="12">
                            <component :is="formularioActivo" :item="item" :accion="accion" :key="componentKey"
                                @close="confirmAndClose(true)" />
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import FormEditarMail from '@/components/forms/FormEditarMail.vue'
import FormEditarDomicilios from '@/components/forms/FormEditarDomicilios.vue'
import FormEditarTelefono from '@/components/forms/FormEditarTelefono.vue'
import FormEditarCuenta from '@/components/forms/FormEditarCuenta.vue'
import FormEditarTarjeta from '@/components/forms/FormEditarTarjeta.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'DialogoAddEdit',

    components: {
        FormEditarDomicilios,
        FormEditarMail,
        FormEditarTelefono,
        FormEditarCuenta,
        FormEditarTarjeta

    },
    //props: ['tipo', 'titulo'],
    props: {
        tipo: {
            type: String,
            required: true,
        },
        item: {
            type: Object,
            required: true,
        }
    },
    mounted() {

    },

    data() {
        return {
            isActive: false,
            componentKey: 0,
            //prueba de callback
            callback: null,
        }
    },
    computed: {
        ...mapGetters(['telefono', 'email', 'domicilio']),
        ...mapGetters('auth', ['isAuthenticated']),
        ...mapGetters('notificaciones', ['loading']),
        ...mapGetters('itemEdit', ['itemSelected']),

        formularioActivo() {
            switch (this.tipo) {
                case 'telefono':
                    return 'FormEditarTelefono'
                case 'email':
                    return 'FormEditarMail'
                case 'domicilio':
                    return 'FormEditarDomicilios'
                case 'cuenta':
                    return 'FormEditarCuenta'

                case 'tarjeta':
                    return 'FormEditarTarjeta'
                default:
                    return null
            }
        },
        accion() {
            if (Object.keys(this.itemSelected).length >= 2)
                return 'modificar'
            else
                return 'alta'

        },
        titulo() {
            if (this.itemSelected.id) {
                return `Editar ${this.tipo}`
            } else if (this.itemSelected.id == undefined) {
                if (this.tipo == 'cuenta' || this.tipo == 'tarjeta') return `Nueva ${this.tipo}`
                else return `Nuevo ${this.tipo}`
            } else {
                return ''
            }
        }


    },
    methods: {
        ...mapActions('auth', ['setSktLoader']),
        ...mapActions('notificaciones', ['showSnack', 'hideSnack']),
        ...mapActions('itemEdit', ['vaciarItem', 'cargarItem']),
        ...mapActions(['refreshData', 'sendTelefono', 'sendDomicilio', 'sendEmail']),

        forceRerender() {
            this.componentKey = Math.floor(Math.random() * Math.pow(10, 17));
        },

        /*  accionContacto(value) {
             switch (this.tipo) {
                 case 'telefono':
                     if (value.recibellamada == 1) {
                         const aux = this.telefono.filter(e => e.id !== value.id).map(e => ({ ...e, recibellamada: 0, accion: "M" }))
                         aux.forEach(elem => {
                             this.sendTelefono(elem)
                         })
                     }
                     this.sendTelefono(value)
                     break;
                 case 'email':
                     if (value.recibeemail == 1) {
                         const aux = this.email.filter(e => e.id !== value.id).map(e => ({ ...e, recibeemail: 0, accion: "M" }))
                         aux.forEach(elem => {
                             this.sendEmail(elem)
                         })
                     }
                     this.sendEmail(value)
                     break;
                 case 'domicilio':
                     if (value.recibecorreo == 1) {
                         const aux = this.domicilio.filter(e => e.id !== value.id).map(e => ({ ...e, recibecorreo: 0, accion: "M" }))
                         aux.forEach(elem => {
                             this.sendDomicilio(elem)
                         })
                     }
                     this.sendDomicilio(value)
                     break;
                 default:
                     this.showSnack({
                         message: `Error: ${this.tipo} NO actualizado.`,
                         type: '400'
                     })
                     break;
             }
             this.confirmAndClose(true)
         }, */

        confirmAndClose(result) {
            if (this.callback) {
                this.callback(result);
                this.callback = null;
            }
            this.isActive = false
            this.vaciarItem()
        },

        abrirDialog() {
            this.componentKey++;
            this.isActive = true;
            return new Promise(resolve => {
                this.callback = resolve;
            })
        }
    }
}
</script>